import React from 'react'
import { Fragment } from 'react'

import './NewOurResultsv2.scss'

const NewOurResults = ({ hideErps, showPedidos }) => (
    <div className="about-achievements">
        <div className="about-achievements-item">
            <h4 className="about-achievements-item-number">+8,7 mil</h4>
            <h4 className="about-achievements-item-text">clientes</h4>
        </div>
        <div className="about-achievements-divider">
        </div>
        <div className="about-achievements-item">
            <h4 className="about-achievements-item-number">+52 mil</h4>
            <h4 className="about-achievements-item-text">usuários</h4>
        </div>

        {!hideErps && (
            <Fragment>
                <div className="about-achievements-divider">
                </div>
                <div className="about-achievements-item">
                    <h4 className="about-achievements-item-number">+250</h4>
                    <h4 className="about-achievements-item-text">ERPs integrados</h4>
                </div>
            </Fragment>
        )}
        <div className="about-achievements-divider">
        </div>
        <div className="about-achievements-item">
            <h4 className="about-achievements-item-number">R$ 78 BI</h4>
            <h4 className="about-achievements-item-text">Anuais movimentados através do Mercos</h4>
        </div>

        {showPedidos && (
            <Fragment>
                <div className="about-achievements-divider">
                </div>
                <div className="about-achievements-item">
                    <h4 className="about-achievements-item-number">+ 14 MI</h4>
                    <h4 className="about-achievements-item-text">de pedidos emitidos por ano</h4>
                </div>
            </Fragment>
        )}
        
    </div>
)

export default NewOurResults



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/NewOurResults/NewOurResultsv2.jsx